import { render, staticRenderFns } from "./v-input.vue?vue&type=template&id=35cf6d76&scoped=true&"
import script from "./v-input.vue?vue&type=script&lang=js&"
export * from "./v-input.vue?vue&type=script&lang=js&"
import style0 from "./v-input.vue?vue&type=style&index=0&id=35cf6d76&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cf6d76",
  null
  
)

export default component.exports